import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './i18n';
import './styles/reference.css';
import './styles/app.css';
import { queryClient } from './api/queryClient';
import { App } from './app/App';
import { ErrorBoundary } from './components/layout/ErrorBoundary';
import { SelectEnhancer } from './components/ui/SelectEnhancer';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary scope="app">
      <QueryClientProvider client={queryClient}>
        <App />
        <SelectEnhancer />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
